export default __webpack_public_path__ + "static/media/TRANPORTE_DASHBOARD_IMG.f96b1a28.jpg";